import baseRequest from './baseRequest';

export const get = async (id: string) => {
  return baseRequest.get(`/api/public/third-party-recipients/${id}`);
};

interface LoginBody {
  id: string;
  disclosuresPackageId?: string;
  verificationCode: string;
  econsentProvided: boolean;
}

export const login = async (body: LoginBody) => {
  return baseRequest.post(`/api/public/login/third-party-recipients`, body);
};
